import type { IResponseEventMessage } from 'entities/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useEventMessageReceivedNewGlobal } from 'entities/Conversation/events/EventMessageReceivedNewGlobal'

export const useEventMessageReceivedNewLog = () => {
  const { dataLogStore } = useEntitiesContext()
  const handler = (data: IResponseEventMessage) => {
    const { message, conversation } = data

    dataLogStore.setItem({
      logLevel: 'info',
      message: 'EventMessageReceivedNewLog',
      details: {
        conversationId: conversation.id,
        messageId: message.id,
      },
    })
  }

  useEventMessageReceivedNewGlobal(handler)
}
